/* eslint-disable */
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { modalActions } from '@/Actions';

/**
 * Returns a stable callback that opens the ChildQrActivitiesModal for a
 * given pack. Single source of truth for the dispatch shape — every
 * consumer (PackScanWiseTable, PackQrTable, future surfaces) imports
 * this hook so the modal contract lives in one place.
 *
 * Usage:
 *   const openChildQrActivities = useOpenChildQrActivitiesModal();
 *   <button onClick={() => openChildQrActivities(row?.packageId, qrCode)}>...</button>
 *
 * No-ops when packageId is falsy.
 */
const useOpenChildQrActivitiesModal = () => {
	const dispatch = useDispatch();
	return useCallback((packageId, packageQr) => {
		if (!packageId) return;
		dispatch(modalActions.toggleChildQrActivitiesModal(true, {
			packageId,
			packageQr,
		}));
	}, [dispatch]);
};

export default useOpenChildQrActivitiesModal;
